import { $$ } from '../../../shared/js/utils/dom';
import { Accordion } from '@3pc/accordion';
import Bus from '../../../shared/js/modules/event-bus';
import { isMobile } from '../../../shared/js/globals/breakpoints';
import { createFocusTrap } from 'focus-trap';

const headerQuicklinkInstances = [];

class HeaderQuicklinks {
  constructor(params) {
    this.el = params.el;
    this.toggle = params.toggle;
    this.content = params.content;
    this.contentInner = params.contentInner;
    this.duration = 400;
    this.accordionInstance = undefined;
    this.isOpen = false;
    this.focusTrapInstance = undefined;
  }

  init() {
    if (!this.toggle || !this.content || !this.contentInner) return;

    this.setupaccordion();
    this.toggle.addEventListener('keydown', this.onKeydown.bind(this));
    this.content.addEventListener('keydown', this.onKeydown.bind(this));
    Bus.subscribe(
      'overlay_hide',
      'HeaderQuicklinksClose',
      this.close.bind(this)
    );
  }

  setupaccordion() {
    const handler = this.toggle;
    const target = this.content;
    const targetInner = this.contentInner;

    this.accordionInstance = new Accordion({
      target,
      targetInner,
      handler,
      duration: this.duration,
      initOpened: false,
      openClassName: 'is-open',
      toggleStart: (_, state) => {
        if (state === 'show') this.isOpen = true;
        if (state !== 'show') this.isOpen = false;
        if (this.isOpen) {
          this.el.classList.add('header-quicklinks--is-open');
          if (!isMobile) {
            this.addFocusTrap();
            Bus.broadcast('header-quicklinks_open', {
              overlayModifier: 'header-quicklinks',
            });
          }
        }
      },
      toggleEnd: (_, state) => {
        if (state !== 'show') {
          if (!this.isOpen) {
            this.el.classList.remove('header-quicklinks--is-open');
            this.removeFocusTrap();
            if (!isMobile) {
              Bus.broadcast('header-quicklinks_close', {
                overlayModifier: 'header-quicklinks',
              });
            }
          }
        }
      },
    });
    this.accordionInstance.init();
  }

  close() {
    this.accordionInstance.close();
    this.removeFocusTrap();
  }

  // Event handler
  onKeydown(e) {
    if (e.key === 'Escape') this.close();
  }

  // Focus handling
  addFocusTrap() {
    this.focusTrapInstance = createFocusTrap(this.el, {
      clickOutsideDeactivates: true,
      initialFocus: this.toggle,
    });
    this.focusTrapInstance.activate();
  }

  removeFocusTrap() {
    this.focusTrapInstance?.deactivate();
  }
}

// General accordion setup
$$('.header-quicklinks').forEach(quicklinks => {
  const accordion = new HeaderQuicklinks({
    el: quicklinks,
    toggle: quicklinks.querySelector('.header-quicklinks__toggle'),
    content: quicklinks.querySelector('.header-quicklinks__content'),
    contentInner: quicklinks.querySelector('.header-quicklinks__content-inner'),
  });
  accordion.init();
  headerQuicklinkInstances.push(accordion);
});
